import api from "services/api";

// Get
export const getLeaveTypes = async () => {
  return api.get("/v1/api/leave-types");
};

// status update tongle
export const updateLeaveTypeStatus = async (leaveTypeId, statusData) => {
  return api.put("/v1/api/leave-types/status", {
    id: leaveTypeId,
    status: statusData,
  });
};
// Create
export const createLeaveType = async (leaveTypeData) => {
  return api.post("/v1/api/leave-types", leaveTypeData);
};

// Update
export const updateLeaveType = async (leaveTypeId, leaveTypeData) => {
  return api.put(`/v1/api/leave-types/${leaveTypeId}`, leaveTypeData);
};

// Delete
export const deleteLeaveType = async (leaveTypeId) => {
  return api.delete(`/v1/api/leave-types/${leaveTypeId}`);
};
